import { defineMessages } from 'react-intl';

export const SUBSIDY_FILTER_ALL = 'all';
export const SUBSIDY_FILTER_SUBSIDY = 'subsidy';
export const SUBSIDY_FILTER_RESIDENT = 'resident';

export const subsidyFilterMessages = defineMessages({
  all: {
    id: 'App.ManagePaymentBatches.SubsidyFilter.All',
    defaultMessage: 'All',
  },
  subsidy: {
    id: 'App.ManagePaymentBatches.SubsidyFilter.Subsidy',
    defaultMessage: 'Subsidy',
  },
  resident: {
    id: 'App.ManagePaymentBatches.SubsidyFilter.Resident',
    defaultMessage: 'Resident',
  },
});

export const SUBSIDY_FILTER_OPTIONS = [
  { value: SUBSIDY_FILTER_ALL, text: subsidyFilterMessages.all },
  { value: SUBSIDY_FILTER_SUBSIDY, text: subsidyFilterMessages.subsidy },
  { value: SUBSIDY_FILTER_RESIDENT, text: subsidyFilterMessages.resident },
];

export const subsidyFilterToQueryValue = (
  subsidyFilter: string,
): boolean | null => {
  if (subsidyFilter === SUBSIDY_FILTER_SUBSIDY) {
    return true;
  }
  if (subsidyFilter === SUBSIDY_FILTER_RESIDENT) {
    return false;
  }
  return null;
};
